<ngb-carousel #carousel [interval]="3000" *ngIf="false">
    <ng-template ngbSlide *ngFor="let img of categories; index as i">
        <div class="carousel-caption">
            <h3>{{img.categoryName}}</h3>
        </div>
        <a rel="nofollow noopener noreferrer">
            <div class="picsum-img-wrapper">
                <img [src]="img.categoryImage" style="width: 100%;height: 400px;object-fit:cover;" alt=" My image {{i +
                    1}} description">
            </div>
        </a>
    </ng-template>
</ngb-carousel>


<div class="carousel-wrapper">
    <div style="width: 90%; margin: 0 auto;">
        <div class="slick-carousel" *ngIf="categories.length">
            <div *ngFor="let card of categories" class="card-container m-3">
                <div class="card home">
                    <img [src]="card.categoryImage" class="card-img-top" [alt]="card.title">
                    <div class="card-body red text-center">
                        <h6  class="card-title text-white">{{card.categoryName}}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
</div>

<section class="section-content padding-y-sm">
    <div class="container">
        <article class="card card-body">


            <div class="row">
                <div class="col-md-4">
                    <figure class="item-feature">
                        <span class="text-primary"><i class="fa fa-2x fa-truck"></i></span>
                        <figcaption class="pt-3">
                            <h5 class="title">Fast delivery</h5>
                            <p>Experience lightning-fast delivery right to your doorstep. We prioritize speed and reliability to ensure your
                            satisfaction every time </p>
                        </figcaption>
                    </figure> <!-- iconbox // -->
                </div><!-- col // -->
                <div class="col-md-4">
                    <figure class="item-feature">
                        <span class="text-primary"><i class="fa fa-2x fa-home"></i></span>
                        <figcaption class="pt-3">
                            <h5 class="title">Creative Strategy</h5>
                            <p>Unlock innovative solutions with our creative strategy. We craft unique approaches that drive impactful results and set
                            you apart from the competition.
                            </p>
                        </figcaption>
                    </figure> <!-- iconbox // -->
                </div><!-- col // -->
                <div class="col-md-4">
                    <figure class="item-feature">
                        <span class="text-primary"><i class="fa fa-2x fa-lock"></i></span>
                        <figcaption class="pt-3">
                            <h5 class="title">High secured </h5>
                            <p>Protecting your data with the latest encryption techniques. Ensuring privacy and security at every level of access. Fortifying systems.
                            </p>
                        </figcaption>
                    </figure> <!-- iconbox // -->
                </div> <!-- col // -->
            </div>
        </article>

    </div> <!-- container .//  -->
</section>
<section class="section-content ">
    <div class="container d-none">
        <div class="row">
            <div class="col-md-4 mb-3 mt-3" *ngFor="let img of categories.slice(0, 3); index as i">
                <div class="card-banner overlay-gradient"
                    style="min-height:230px; background-image: url('{{img.categoryImage}}');">
                    <div class="card-img-overlay text-white">
                        <h5 class="card-title">{{img.categoryName}}</h5>
                        <p class="card-text">{{img.description}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
    <div class="row">
        <div class="col-12">
            <div class="section-title text-center">
                <h3 style=" text-decoration: overline;
  text-decoration-color: red; /* Set the color of the overline */
  text-decoration-thickness: 4px;" class="title mt-5">POPULAR PRODUCTS</h3>
  <p>Experience lightning-fast delivery right to your doorstep. We prioritize speed and reliability to ensure your
satisfaction every time, Unlock innovative solutions with our creative strategy. We craft unique approaches that drive impactful results and set
you apart from the competition.</p>
                
            </div>
        </div>
    </div>
        <app-products></app-products>
    </div>
</section>